// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/user/login',
  },
  DEFINITIONS: {
    BASE: (orgId: string) => `/${orgId}/definitions`,
    CREATE: (orgId: string) => `/${orgId}/definition`,
    BY_ID: (orgId: string, id: string) => `/${orgId}/definitions/${id}`,
    PROTO_FILE: (orgId: string, id: string) => `/${orgId}/definitions/${id}/protoFile`,
  },
  GAMEDATA: {
    BASE: (orgId: string) => `/${orgId}/gamedata`,
    BY_ID: (orgId: string, id: string) => `/${orgId}/gamedata/${id}`,
    DECODE: (orgId: string, id: string, bundleName: string) => `/${orgId}/gamedata/${id}/decode/${bundleName}`,
  },
  ENVIRONMENTS: {
    BASE: (orgId: string) => `/${orgId}/environments`,
    CREATE: (orgId: string) => `/${orgId}/environment`,
    BY_NAME: (orgId: string, envName: string) => `/${orgId}/environment/${envName}`,
    BY_ID: (orgId: string, envId: string) => `/${orgId}/environment/${envId}`,
    DETAILS: (orgId: string, envName: string) => `/${orgId}/environment/${envName}`,
    CONFIGS: (orgId: string, envId: string) => `/${orgId}/environment/${envId}/configs`,
  },
  ORGANIZATION: {
    CREDENTIALS: (orgId: string) => `/${orgId}/config/credentials`,
    UPLOAD_CREDENTIALS: (orgId: string) => `/${orgId}/config/credentials`,
    INFO: (orgId: string) => `/${orgId}/organization`,
    CONFIG: (orgId: string) => `/${orgId}/config`,
    DATASOURCE: (orgId: string) => `/${orgId}/organization/datasource`,
    DATASOURCES: (orgId: string) => `/${orgId}/organization/datasources`,
    DELETE_DATASOURCE: (orgId: string, datasourceId: string) => `/${orgId}/organization/datasource/${datasourceId}`,
  },
  AI_CHAT: {
    ASK: (orgId: string) => `/${orgId}/organization/clanker/ask`,
  },
} as const;



// Build Status Options
export const BUILD_STATUSES = {
  SUCCESS: 'success',
  RUNNING: 'running',
  FAILED: 'failed',
  PENDING: 'pending',
} as const;

// Status Color Mapping
export const STATUS_COLORS = {
  [BUILD_STATUSES.SUCCESS]: 'bg-green-100 text-green-800',
  [BUILD_STATUSES.RUNNING]: 'bg-blue-100 text-blue-800',
  [BUILD_STATUSES.FAILED]: 'bg-red-100 text-red-800',
  [BUILD_STATUSES.PENDING]: 'bg-yellow-100 text-yellow-800',
} as const;

// Form Configuration
export const FORM_CONFIG = {
  LOGIN: {
    FIELDS: [
      { name: 'email', label: 'Email address', type: 'email', required: true },
      { name: 'password', label: 'Password', type: 'password', required: true },
    ],
  },
  NEW_BUILD: {
    FIELDS: [
      { name: 'name', label: 'Build Name', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'textarea', rows: 4 },
    ],
    OPTIONS: [
      { id: 'option1', label: 'Enable data validation' },
      { id: 'option2', label: 'Include metadata' },
      { id: 'option3', label: 'Generate reports' },
    ],
  },
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
} as const;

// Environment Variables
export const ENV_VARS = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001/api',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'BSK Admin',
} as const;
